module.exports = __webpack_public_path__ + "static/img/bg10.a5fe852.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/bg10.png
// module id = pwsk
// module chunks = 1